import { useQuery } from "@tanstack/react-query";
import { getDashboard } from "../api/transcriptions";

export const useSidekickDashboard = ({ range, team }) => {
  return useQuery({
    queryKey: ["sidekick-dashboard", range, team],
    queryFn: async () => {
      const res = await getDashboard({ range, team: team || undefined });
      return res.data.data;
    },
    // Keep the last render on screen while a filter change refetches.
    keepPreviousData: true,
    staleTime: 60000,
  });
};
